import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './index';

export interface FunnelMapsState {
  funnelMapsList: FunnelMap[];
  isLoading: boolean;
}

const initialState: FunnelMapsState = {
  funnelMapsList: [],
  isLoading: false,
};

export const funnelMapsSlice = createSlice({
  name: 'funnelMaps',
  initialState,
  reducers: {
    setFunnelMapsList: (state, action: PayloadAction<{ funnelMapsList: FunnelMap[] }>) => {
      state.isLoading = false;
      state.funnelMapsList = action.payload.funnelMapsList;
    },
    setLoadingFunnelMapsList: (state) => {
      state.isLoading = true;
    },
    updateFunnelMapName: (
      state,
      action: PayloadAction<{ funnelMapNewName: string; funnelMapId: string; version?: number }>,
    ) => {
      const { funnelMapNewName, funnelMapId, version } = action.payload;
      state.funnelMapsList = state.funnelMapsList.map((funnelMap) => {
        if (funnelMap.id === funnelMapId) {
          const updatedFunnelMapWrapper = funnelMap;
          updatedFunnelMapWrapper.name = funnelMapNewName;
          if (version !== undefined) {
            updatedFunnelMapWrapper.version = version;
          }
          return updatedFunnelMapWrapper;
        }
        return funnelMap;
      });
    },
    deleteFunnelMapFromList: (state, action: PayloadAction<{ funnelMapId: string }>) => {
      state.funnelMapsList = state.funnelMapsList.filter(
        (funnelMap) => funnelMap.id !== action.payload.funnelMapId,
      );
    },
    setIsPinned: (state, action: PayloadAction<{ funnelMapId: string; isPinned: boolean }>) => {
      const { funnelMapId, isPinned } = action.payload;
      state.funnelMapsList = state.funnelMapsList.map((funnelMap) => {
        funnelMap.isPinned = isPinned && funnelMap.id === funnelMapId;
        return funnelMap;
      });
    },
  },
});

export const selectFunnelMapsList = (state: RootState) => state.funnelMaps.funnelMapsList;
export const selectFunnelMapsIsLoading = (state: RootState) => state.funnelMaps.isLoading;

export const selectPinnedFunnelMap = (state: RootState) =>
  state.funnelMaps.funnelMapsList.find((funnelMap) => funnelMap.isPinned); //there should be only 1

export const {
  setFunnelMapsList,
  setLoadingFunnelMapsList,
  deleteFunnelMapFromList,
  updateFunnelMapName,
  setIsPinned,
} = funnelMapsSlice.actions;

export default funnelMapsSlice.reducer;
